export const locale = {
    lang: 'en',
    data: {
        'MODULE': {
            'TITLE': 'Training Modules'
        }
    }
};



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/modules/i18n/en.ts